const AppMessages = {
   
    pendingMsg1: "YOUR REQUEST IS CURRENTLY PENDING",   
    pendingMsg2: "Thank you for requesting the [MERCHANT_NAME] credit product, issued by Synchrony Bank. In order to continue the application process, more information is required from you. Please do not resubmit this request as it will not increase the likelihood of an approval.",
    pendingMsg3: "Please call 1-877-794-8400 to complete your Credit Card application process.",
    pendingMsg4: "Please call 1-855-872-6189 to complete your SetPay installment application process."
 

}
export default AppMessages;
